import Reveal from "@/components/feature/Reveal";
import { aboutSbdc } from "@/mocks/clinic";

export default function AboutSbdc() {
  return (
    <section id="about" className="bg-background-100 py-24 md:py-32 lg:py-40">
      <div className="u-container">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20">
          <Reveal>
            <div className="lg:sticky lg:top-32">
              <span className="en-eyebrow text-[11px] text-secondary-700">{aboutSbdc.headingEn}</span>
              <span className="mt-5 block h-px w-12 bg-accent-500" />
              <h2 className="mt-7 font-heading text-[26px] leading-[1.6] text-foreground-950 md:text-[34px] whitespace-pre-line">
                {aboutSbdc.headingJp}
              </h2>

              <div className="mt-10 grid grid-cols-3 gap-4 border-t border-background-300/80 pt-8">
                {aboutSbdc.stat.map((stat) => (
                  <div key={stat.label}>
                    <span className="font-label text-xl tracking-wide text-foreground-900 md:text-2xl">
                      {stat.value}
                    </span>
                    <span className="ml-0.5 font-label text-[11px] text-secondary-700">{stat.unit}</span>
                    <span className="mt-2 block text-[11px] leading-relaxed text-foreground-600">{stat.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="space-y-8 md:space-y-9">
              {aboutSbdc.paragraphs.map((paragraph, index) => (
                <p
                  key={paragraph}
                  className={`max-w-[46rem] ${
                    index === 0
                      ? "font-heading text-[17px] leading-[1.85] text-foreground-950 md:text-[19px] md:leading-[1.9]"
                      : "text-[14px] leading-[1.9] text-foreground-800 md:text-[15px] md:leading-[2] lg:text-[16px]"
                  }`}
                >
                  {paragraph}
                </p>
              ))}
              <span className="block h-px w-16 bg-accent-500" />
              <p className="font-heading text-[15px] tracking-wide text-foreground-800">
                渋谷美容皮膚科クリニック
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}